import { useSaleOperationLoaders } from "../../sales"
import { useCreditPaymentLoaders } from "../loaders/creditPaymentLoaders"
import { usePaymentOrderLoaders } from "../loaders/paymentOrderLoaders"
import { usePaymentTypeLoaders } from "../loaders/paymentTypeLoaders"
import { useSettingsLoaders } from "../loaders/settingsLoaders"
import { DocumentPaymentTypeIdsData, PaymentCategory, SettingsModule } from "../state/types"

export const usePaymentTypeHooks = () => {
    const paymentTypeLoaders = usePaymentTypeLoaders()
    const paymentOrderLoaders = usePaymentOrderLoaders()
    const saleOperationLoaders = useSaleOperationLoaders()
    const creditPaymentLoaders = useCreditPaymentLoaders()
    const settingsLoaders = useSettingsLoaders()

    const getPaymentTypeYield = (paymentTypeId?: string) => {
        return paymentTypeLoaders().findPaymentType(paymentTypeId)?.yield || 0
    }

    const isCreditAccount = (paymentTypeId?: string) => {
        return paymentTypeLoaders().findPaymentType(paymentTypeId)?.category === PaymentCategory.CREDIT_ACCOUNT
    }

    const canRemovePaymentType = async (paymentTypeId: string): Promise<boolean> => {
        const { loadPaymentOrdersWithProp } = paymentOrderLoaders()
        const paymentOrdersWithPaymentItems = await loadPaymentOrdersWithProp('paymentItems', true)
        const paymentOrders = paymentOrdersWithPaymentItems.filter(paymentOrder => paymentOrder.paymentItems.some(paymentItem => paymentItem.paymentTypeId === paymentTypeId))
        
        const { countSaleOperations, loadSaleOperationsWithProp } = saleOperationLoaders()
        const saleOperationsCount = await countSaleOperations('paymentTypeId', paymentTypeId)
        const saleOperationsWithPaymentItems = await loadSaleOperationsWithProp('paymentItems', true)
        const saleOperations = saleOperationsWithPaymentItems.filter(saleOperation => saleOperation.paymentItems.some(paymentItem => paymentItem.paymentTypeId === paymentTypeId))
        
        const { countCreditPayments } = creditPaymentLoaders()
        const creditPaymentsCount = await countCreditPayments('paymentTypeId', paymentTypeId)

        const { loadModuleSettings } = settingsLoaders()
        const saleSettings = await loadModuleSettings(SettingsModule.SALES)
        const inSettings = Object.values(saleSettings.documentPaymentTypeIds || {}).some((documentPaymentTypeIdsData: DocumentPaymentTypeIdsData) =>
            Object.values(documentPaymentTypeIdsData).some(data => data.paymentTypeIds.includes(paymentTypeId))
        )

        return paymentOrders.length === 0 &&
            saleOperationsCount === 0 &&
            saleOperations.length === 0 &&
            creditPaymentsCount === 0 &&
            !inSettings
    }

    return {
        getPaymentTypeYield,
        isCreditAccount,
        canRemovePaymentType
    }
}
